import React from "react"; 
import { PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import { DATE_FORMAT } from '../../../../../constants/constants';
import { DateUtil } from '../../../../../util/DateUtil';
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";
import { MessageUtil } from "../../../../../util/MessageUtil";
 
class DatosServiciosSection extends BasePage {
    renderPage(pageApi) {
    const getForm_datosserviciosSS = () => pageApi.getComponent('form');
      
    const form_datosserviciosSS = {
      layout: 'vertical',
        load:{
          queryId: 263,
          search: true,
          hideMessage: true,
          hideMessageError: true, 
          params: { id_doc: pageApi.getParamId() }
        },
        save: { 
          queryId: 821, 
          params: { est_tab : 3,id_SS : pageApi.getParamId(), id_user: UserUtil.getUserId()},
          fnOk: (resp) => {
            const id_doc = resp.dataObject?.id_doc;  
            const est_tab_actual = resp.dataObject?.est_tab;    

            if(est_tab_actual == 3){
              this.props.history.push(`/servicios-ejecutados/servicios-ejecutados/3/${id_doc}`)
            }
            
            this.props.cambiarTabPanel("3",id_doc); 
            return MessageUtil(
              "success",
              "Exito!",
              "Se ha habilitado Puntos de Muestreo"
            ); 
          }, 
        },
        title: '',
        //collapsible: true,
        fields:[ 
            {
                label: '  ',
                fields: [
                  {type: 'hidden', name: 'id_doc'},  
                  {name: "referencia_proyecto", label: "Referencia/Proyecto", column: 6,}, 
                  {type: 'date', name:'fecha_servicio', label: 'Fecha Inicio de Servicio',column: 2, format: 'DD/MM/YYYY',inputFormat: DATE_FORMAT.YYYYMMDD, value: DateUtil.getDate},
                  {type: 'date', name:'fecha_final', label: 'Fecha Fin de Servicio',column: 2, format: 'DD/MM/YYYY',inputFormat: DATE_FORMAT.YYYYMMDD, value: DateUtil.getDate},
                  {name: 'lugar_toma', label: 'Lugar de Toma de Muestras',column: 4},
                  {type: 'date', name:'fecha_prevista_muestreo', label: 'Fecha Muestreo',column: 4, format: 'DD/MM/YYYY',inputFormat: DATE_FORMAT.YYYYMMDD},
                  {type: 'date', name:'hora_inicio_muestreo', label: 'Hora Muestreo',column: 4, format: 'HH:mm', inputFormat: DATE_FORMAT.HHmm},
                  {type: "textarea", name: "observaciones", label: "Observaciones", column: 12, }, 
                ]   
            }
        ],
        onComponentLoad : (formApi, pageApi) =>{
          if (pageApi.getPageMode() !== PAGE_MODE.NEW)
              formApi.load();
      } 
    }
 
    const barButtonFooter_datosserviciosSS = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN,label: "Retornar al Inicio", link: '/servicios-ejecutados/servicios-ejecutados-admin', alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE, label: "Guardar y Continuar",onClick: () => { getForm_datosserviciosSS().save() } }, 
        ]
    }
  
    return (
      <>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={form_datosserviciosSS} 
        />
 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter_datosserviciosSS} 
        /> 
      </>
    ); 
  }
} 
export default DatosServiciosSection